import { Button, Form, Input, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import React, { useContext } from 'react'
import UploadImg from '../columns/components/uploadImg'
import { shopLogClstag } from '../../../shop/log'
import { erpLogClstag } from '../../../erp/log'
import { TableContext, AppTypeContext } from '../../'
import './index.less'
import { restrictCNLength } from '../../utils'

const { confirm } = Modal

const smartPicTransparent = {
  code: 'picUrl',
  dataType: 2,
  displayType: 0,
  id: 'smartPicTransparent',
  itemOptionVOList: [],
  formItem: true,
  width: 130,
  titleInfo: (
    <div>
      要求：800px*800px，72分辨率，PNG格式，小于1M；透明图商品主体要与主图一致，不可扣图破损，不可扣图不干净，不可有影子，不可出现LOGO，除商品以外所有文字促销水印信息，图片需要满画布产品居中展示，左右或者上下顶边。如违规会被驳回，请确认无误后保存！【透明图规范】
      <a
        href="https://pro.jd.com/mall/active/SLULn5voab5iB92t9ZLCDUCTBks/index.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        (https://pro.jd.com/mall/active/SLULn5voab5iB92t9ZLCDUCTBks/index.html)
      </a>
    </div>
  ),
  itemRuleVOList: [
    { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
    { errorTip: '不满足图片宽', ruleCode: 'imgWidth', ruleType: 10, ruleValue: '800' },
    { errorTip: '不满足图片高', ruleCode: 'imgHeight', ruleType: 10, ruleValue: '800' },
    { errorTip: '超出图片大小', ruleCode: 'imgSize', ruleType: 10, ruleValue: '1024' },
    { errorTip: '图片格式不符合要求', ruleCode: 'imgExtension', ruleType: 10, ruleValue: 'png' },
  ],
  name: '商品透底图',
  remark: '',
  seq: 4,
  subFormItemVOList: [],
  systemDefault: 1,
  usable: 1,
}

const smartPicWhite = {
  code: 'smartPicWhite',
  dataType: 2,
  displayType: 0,
  id: 'smartPicWhite',
  itemOptionVOList: [],
  formItem: true,
  width: 130,
  titleInfo: (
    <div>
      要求：800px*800px，72分辨率，JPG格式，小于2M；白底图需为纯白背景，商品需居中展示，不可破损，不可展示细节图，尽量铺满画布；禁止出现LOGO、边框、除商品本身以外的所有文字促销水印信息。如违规会被驳回，请确认无误后保存！【白底图规范】
      <a
        href="https://pro.jd.com/mall/active/2bwZShUsrzqABevVWfu6BoEZxjwN/index.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        (https://pro.jd.com/mall/active/2bwZShUsrzqABevVWfu6BoEZxjwN/index.html)
      </a>
    </div>
  ),
  itemRuleVOList: [
    { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
    { errorTip: '不满足图片宽', ruleCode: 'imgWidth', ruleType: 10, ruleValue: '800' },
    { errorTip: '不满足图片高', ruleCode: 'imgHeight', ruleType: 10, ruleValue: '800' },
    { errorTip: '超出图片大小', ruleCode: 'imgSize', ruleType: 10, ruleValue: '2048' },
    { errorTip: '图片格式不符合要求', ruleCode: 'imgExtension', ruleType: 10, ruleValue: 'jpg,jpeg' },
  ],
  name: '商品白底图',
  titleExtra: '',
  remark: '',
  seq: 4,
  subFormItemVOList: [],
  systemDefault: 1,
  usable: 1,
}

const ApplyModal = ({ visible = false, setVisible, batchSave, editMutApplyRes, selectedRowKeys }) => {
  const { uploadImgUrl } = useContext(TableContext)
  const appType = useContext(AppTypeContext)
  const [form] = Form.useForm()

  const smartContentSell = (name) => {
    return (
      <Form.Item
        name={name}
        validateTrigger="onBlur"
        rules={[
          {
            validator: (r, val) => {
              const a = form.getFieldValue('smartContentSell')
              const b = form.getFieldValue('smartContentSell2')
              const c = form.getFieldValue('smartContentSell3')
              if (val) {
                if (restrictCNLength(val) < 3) {
                  return Promise.reject(new Error(`不能少于3个字`))
                } else if (restrictCNLength(val) > 14) {
                  return Promise.reject(new Error(`不能多于7个字`))
                }
              }
              if ((a && b) || (b && c) || (a && c)) {
                return Promise.resolve()
              } else {
                if (!val) {
                  return Promise.reject(new Error(`请输入营销卖点`))
                }
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <Input autoComplete="off" placeholder="3~7个字" style={{ width: 140, marginRight: 15 }}></Input>
      </Form.Item>
    )
  }
  const smartContentSortTitle = (name) => {
    return (
      <Form.Item
        name={name}
        validateTrigger="onBlur"
        rules={[
          {
            validator: (r, val) => {
              if (!val) {
                return Promise.reject(new Error(`请输入营销短标题 `))
              } else if (restrictCNLength(val) < 8) {
                return Promise.reject(new Error(`不能少于4个汉字`))
              } else if (restrictCNLength(val) > 16) {
                return Promise.reject(new Error(`不能多于8个汉字`))
              } else {
                return Promise.resolve()
              }
            },
          },
        ]}
      >
        <Input autoComplete="off" placeholder="4~8个汉字" style={{ width: 200, marginRight: 15 }}></Input>
      </Form.Item>
    )
  }
  const formImage = (name, data) => {
    return (
      <Form.Item
        name={name}
        rules={[
          {
            required: true,
            message: `请上传图片`,
          },
        ]}
      >
        <UploadImg data={data} uploadImgUrl={uploadImgUrl} />
      </Form.Item>
    )
  }

  const stepIcon = (number) => {
    return <div className="step-round">{number}</div>
  }

  const onFinish = (e) => {
    const out = []
    selectedRowKeys.forEach((skuId) => {
      out.push({
        ...e,
        skuId,
      })
    })
    batchSave(out, (res) => {
      if (res) {
        editMutApplyRes(res, out)
        setVisible(false)
        form.resetFields()
      }
    })
  }
  return (
    <Modal
      className="material-apply-modal"
      width={600}
      visible={visible}
      title="批量完善商品素材"
      footer={null}
      bodyStyle={{ padding: 0 }}
      onCancel={() => {
        confirm({
          title: '您更新的内容还未保存，是否确定退出?',
          icon: <ExclamationCircleOutlined />,
          onOk() {
            setVisible(false)
            form.resetFields()
          },
        })
      }}
    >
      <Form form={form} onFinish={onFinish}>
        <div style={{ padding: '26px 23px 0 23px' }}>
          <div className="title">{stepIcon(1)}填写营销卖点（至少2条）</div>
          <div className="smartContentSell">
            {smartContentSell('smartContentSell')}
            {smartContentSell('smartContentSell2')}
            {smartContentSell('smartContentSell3')}
          </div>
          <div className="title">{stepIcon(2)}填写营销短标题</div>
          {smartContentSortTitle('smartContentSortTitle')}
          <div className="img">
            <div className="img-line">
              <div className="title">{stepIcon(3)}完善透底图</div>
              {formImage('smartPicTransparent', smartPicTransparent)}
            </div>
            <div className="img-line">
              <div className="title">{stepIcon(4)}完善白底图</div>
              {formImage('smartPicWhite', smartPicWhite)}
            </div>
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <Form.Item className="opt-btn">
            <Button
              clstag={appType === 'shop' ? shopLogClstag['batchModalOkClick'] : erpLogClstag['batchModalOkClick']}
              shape="round"
              type="primary"
              htmlType="submit"
              style={{ width: 66, marginRight: 16 }}
            >
              保存
            </Button>
            <Button
              shape="round"
              clstag={
                appType === 'shop' ? shopLogClstag['batchModalCancelClick'] : erpLogClstag['batchModalCancelClick']
              }
              style={{ width: 66 }}
              onClick={() => {
                confirm({
                  title: '您更新的内容还未保存，是否确定退出?',
                  icon: <ExclamationCircleOutlined />,
                  onOk() {
                    setVisible(false)
                    form.resetFields()
                  },
                })
              }}
            >
              取消
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}

export default ApplyModal
